export const BLANK_TEXT = '---';

export type PagintionType<T> = {
  nextPage: number;
  pageCount: number;
  pageSize: number;
  count: number;
  data: T[];
};
